import { Injectable } from '@angular/core';
import { MatDateFormats, NativeDateAdapter } from '@angular/material/core';

/**
 * Date adapter for typed dates in Argentina: "01/09/2026" is September 1st.
 * The native adapter parses with Date.parse, which always reads month/day ("01/09/2026" became January 9th and
 * "30/09/2026" was invalid). Display stays dd/MM/yyyy, the same format the app prints everywhere else.
 */
@Injectable()
export class EsArDateAdapter extends NativeDateAdapter {
  override parse(value: any, parseFormat?: any): Date | null {
    if (typeof value === 'string') {
      const match = value.trim().match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{2}|\d{4})$/);
      if (match) {
        const day = Number(match[1]);
        const month = Number(match[2]) - 1;
        const year = match[3].length === 2 ? 2000 + Number(match[3]) : Number(match[3]);
        const date = new Date(year, month, day);
        // Out of range values ("31/02/2026") roll over in JS; treat them as invalid instead.
        return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day
          ? date
          : this.invalid();
      }
      if (value.trim() === '') {
        return null;
      }
    }
    return super.parse(value, parseFormat);
  }

  override format(date: Date, displayFormat: Object): string {
    if (displayFormat === ES_AR_DATE_FORMATS.display.dateInput) {
      if (!this.isValid(date)) {
        throw Error('EsArDateAdapter: Cannot format invalid date.');
      }
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      return `${dd}/${mm}/${date.getFullYear()}`;
    }
    return super.format(date, displayFormat);
  }
}

export const ES_AR_DATE_FORMATS: MatDateFormats = {
  parse: { dateInput: 'dd/MM/yyyy' },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};
